import { idSchema } from "@reactive-resume/schema";
import { dateSchema } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const auditLogSchema = z.object({
  id: idSchema,
  userId: z.string().nullable(),
  action: z.string(),
  resource: z.string(),
  resourceId: z.string().nullable(),
  changes: z.record(z.any()).nullable(),
  status: z.enum(["success", "failure", "warning"]).default("success"),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  metadata: z.record(z.any()).nullable(),
  createdAt: dateSchema,
});

export class AuditLogDto extends createZodDto(auditLogSchema) {}

export const filterAuditLogSchema = z.object({
  userId: z.string().optional(),
  action: z.string().optional(),
  resource: z.string().optional(),
  status: z.enum(["success", "failure", "warning"]).optional(),
  startDate: dateSchema.optional(),
  endDate: dateSchema.optional(),
  page: z.number().positive().default(1),
  limit: z.number().positive().max(100).default(20),
});

export class FilterAuditLogDto extends createZodDto(filterAuditLogSchema) {}
